class RegisterModal extends ModalElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === "/challenge" || !theme.cookiesEnabled) {
      return;
    }

    // Sitewide setup
    this.setupListeners();
  }

  get shouldLock() {
    return true;
  }

  get testMode() {
    return this.dataset.testMode === "true";
  }

  get delay() {
    return parseInt(this.dataset.delay) || 0;
  }

  get expiry() {
    return parseInt(this.dataset.expiry) || 0;
  }

  get submited() {
    return this.querySelector(".alert") !== null;
  }

  setupListeners() {
    document.addEventListener("DOMContentLoaded", () => {
      const modal = this;

      const excludedPaths = [
        "/account/login",
        "/pages/request-registration",
        "/challenge"
      ];

      // Detect if the user is on a collection page
      if (!excludedPaths.includes(window.location.pathname)) {
        // Store referrer URL in sessionStorage
        sessionStorage.setItem("collection_referrer", window.location.pathname);
        
        // Show modal
        modal.init();
      }

      // Open modal on button click
      const resourceButtons = document.querySelectorAll(
        ".resources-column .multicolumn-card .multicolumn-card__info a.button"
      );

      if (resourceButtons.length > 0) {
        resourceButtons.forEach((button) => {
          button.addEventListener("click", (event) => {
            event.preventDefault(); // Prevent default navigation

            // Open modal
            modal.removeAttribute("inert");
            modal.hidden = false;
            modal.setAttribute("open", "");
            modal.show();
          });
        });
      }

      // Check if the user just registered and redirect them back
      modal.redirectAfterSignup();
    });
  }

  init() {
    // Open modal if errors or success message exist
    if (this.submited) {
      this.load(1);
      return;
    }

    // Load modal automatically for collection pages
    this.load(this.delay);
  }

  load(delay) {
    if (Shopify && Shopify.designMode) return;

    setTimeout(() => this.show(), delay * 1000);
  }

  afterShow() {
    super.afterShow();
    this.classList.add("show-image");
    this.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  
    // Also block ESC key just in case
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  hide() {
    // Completely disable closing
    return false;
  }

  afterHide() {
    super.afterHide();
    this.classList.remove("show-image");
  }

  show() {
    super.show();
  }

  redirectAfterSignup() {
    // Check if the form was submitted and user should be redirected
    if (this.submited) {
      const collectionURL = sessionStorage.getItem("collection_referrer");

      if (collectionURL) {
        // Redirect user back to the collection page
        setTimeout(() => {
          window.location.href = collectionURL;
        }, 2000); // Delay redirection by 2 seconds for better UX
      }
    }
  }
}

customElements.define("register-modal", RegisterModal);